import { SVGProps } from 'react';

const SvgOptionsNotes = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 22 26" {...props}>
    <path
      stroke="#2196F3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7 6.333h8m-8 5.334h8M7 17h5.333M1.667 3.667A2.667 2.667 0 0 1 4.333 1h13.334a2.667 2.667 0 0 1 2.666 2.667v18.666A2.667 2.667 0 0 1 17.667 25H4.333a2.667 2.667 0 0 1-2.666-2.667z"
    />
  </svg>
);
export default SvgOptionsNotes;
